import Input from "components/atoms/Input";
import { useEffect, useState } from "react";
import  i18next  from 'i18next';
import { fieldHelperText } from "utils/fieldError.util";

export default function InputRedux({
	input,
	InputProps,
	handleBlur,
	handleFocus,
	meta: { error, touched, invalid, submitFailed },
	required,
	...rest
}: any) {
	const [cError , setCError] = useState(i18next.t(`${error}`));
	const [currentLanguage,setCurrlang]=useState(i18next.language);
	// Keep error visible until the field is valid (fill clears it; focus does not)
	const showError =
		Boolean(invalid && error && (submitFailed || touched));
	if(currentLanguage !== i18next.language){
		setCurrlang(i18next.language)
	}
	useEffect(()=>{
		setCError(i18next.t(`${error}`));
	},[error,currentLanguage])
	return (
		<Input
			{...InputProps}
			{...rest}
			{...input}
			/* `required` here means "mark it"; the Input atom adds the asterisk
			   and aria-required without MUI's native attribute. */
			markRequired={required}
			helperText={fieldHelperText(showError, error, cError)}
			error={showError}
			onBlur={(e) => {
				input?.onBlur?.(e);
				handleBlur?.(e);
			}}
			onFocus={(e) => {
				input?.onFocus?.(e);
				handleFocus?.(e);
			}}
		/>
	);
}
